import { useState } from 'react'

import { useAssistantBrowserCommand } from '@/lib/assistant-browser-commands'
import { assistantBrowserCommands } from '@/lib/assistant-browser-commands.generated'

export function usePrinterPolicyGroup(entityId: string, valueType: string, enabled: boolean) {
  const [expanded, setExpanded] = useState(true)
  useAssistantBrowserCommand(assistantBrowserCommands.printerPolicyGroup, (command) => {
    setExpanded(command.expanded)
    return true
  }, (command) => enabled && command.entityId === entityId && command.valueType === valueType)
  return { expanded, setExpanded }
}
